export function processSelfUrlMobile(url: string) {
  url = url.replace('nmforsmu:///', 'nmforsmu://mobile/');
  return url.startsWith('file:///') ? url.replace('file:///', 'nmforsmu://mobile/') : url;
}
